// extracted by mini-css-extract-plugin
module.exports = {"flagContainer":"FCf3","flag":"Ry-p","leftFlag":"TNtk","rightFlag":"BaQh"};